import { gql } from '@apollo/client';

export const postEsClienteProvinciaCompras = gql`
mutation EsClienteRQ{
    EsClienteRQ(input: $input)  
        @rest(type: "EsClienteProvinciaComprasRS", path: "/api/gateway/formularios/AdhesionProvinciaCompras",  method: "PATCH"){
            sucursal
            ubicom
            razonSocial
        }
}
`